

















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    serviceFeeCompute: [ {
        prices: {
            quotation: {
                priceExcludingTax: number;
                priceIncludingTax: number;
            },
        },
    }];
}

@Component({ components: { SimpleText } })
export default class AdSpaceQuotation extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.adSpaceCompute",
        ];
    }
}
